import type { GameStats } from "../game/game";

function clock(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds - m * 60;
  return `${String(m).padStart(2, "0")}:${s.toFixed(2).padStart(5, "0")}`;
}

/** Bare-bones driving HUD for Phase 1: speed, run time and a crash / finish call-out. Real HUD is Phase 3. */
export function Hud({ stats }: { stats: GameStats }) {
  return (
    <>
      <div
        class="pointer-events-none absolute flex items-baseline gap-2 font-display text-neon-cyan"
        style={{
          right: "calc(var(--safe-right) + 16px)",
          bottom: "calc(var(--safe-bottom) + 12px)",
        }}
      >
        <span class="text-5xl leading-none">{Math.round(stats.speedKmh)}</span>
        <span class="font-mono text-2xs uppercase tracking-widest text-text-secondary">km/h</span>
      </div>
      <div
        class="pointer-events-none absolute font-mono text-lg text-text-primary"
        style={{ right: "calc(var(--safe-right) + 16px)", top: "calc(var(--safe-top) + 10px)" }}
      >
        {clock(stats.finished ? stats.finishSeconds : stats.runSeconds)}
      </div>
      {stats.crashHold && (
        <div class="pointer-events-none absolute inset-x-0 top-1/3 text-center font-display text-4xl uppercase tracking-widest text-neon-crimson">
          Crash
        </div>
      )}
      {stats.finished && (
        <div class="pointer-events-none absolute inset-x-0 top-1/3 text-center">
          <div class="font-display text-4xl uppercase tracking-widest text-arcade-yellow">
            Finish
          </div>
          <div class="font-mono text-sm text-text-secondary">
            {clock(stats.finishSeconds)} · Enter to restart
          </div>
        </div>
      )}
      <div
        class="pointer-events-none absolute font-mono text-2xs uppercase tracking-widest text-text-muted"
        style={{ left: "calc(var(--safe-left) + 10px)", bottom: "calc(var(--safe-bottom) + 8px)" }}
      >
        W throttle · S brake, hold to reverse · A/D steer · Space handbrake · R reset · Enter
        restart · ` overlay
        {import.meta.env.DEV ? " · T tuning" : ""} · X assists
      </div>
    </>
  );
}
